// AUTO-GENERATED by scripts/build-registry.js: study entry for aeronautics/longitudinal-stability-mechanism.
import { mount } from '#engine/lesson-page.js';
import g0 from '../lessons/aeronautics/longitudinal-stability-mechanism/centre-of-pressure-movement.js';
import g1 from '../lessons/aeronautics/longitudinal-stability-mechanism/longitudinal-stability-mechanism.js';

mount([g0, g1]);
